// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"backdrop_backdrop__33X24"};